import { missingNativeBuild } from "../nativeError";
var MapServices = Object.freeze({
  search: function search(_query, _center) {
    var _radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
    return Promise.resolve([]);
  },
  autocomplete: function autocomplete(_query, _center) {
    var _radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
    return Promise.resolve([]);
  },
  resolveSuggestion: function resolveSuggestion(_id) {
    return Promise.reject(missingNativeBuild("MapServices.resolveSuggestion"));
  },
  directions: function directions(_origin, _destination) {
    var _transport = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "driving";
    return Promise.reject(missingNativeBuild("MapServices.directions"));
  }
});
export {
  MapServices
};
//# sourceMappingURL=unavailable.js.map
